import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { BaseThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';

import { RequestError } from 'errors/RequestError';

const rejectWithValueHelper = (
  error: Error,
  thunkApi: BaseThunkAPI<
    unknown,
    unknown,
    ThunkDispatch<unknown, unknown, AnyAction>,
    unknown,
    unknown,
    unknown
  >,
) => {
  if (error instanceof RequestError) {
    return thunkApi.rejectWithValue({
      responseStatus: error.responseStatus,
      message: error.message,
    });
  }

  throw error;
};

export default rejectWithValueHelper;
